import React, { useState, useEffect, useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import SpDash from "./SpDash";
import SpJobsList from "./SpJobsList";
import SpJobDetail from "./SpJobDetail";
import SpHistory from "./SpHistory";
import SpEarnings from "./SpEarnings";
import PhotoUpload from "./PhotoUpload";
import SettingsPage from "../landlord/SettingsPage";
import FaqPage from "../landlord/FaqPage";
import ProfilePage from "../common/ProfilePage";
import TermsPage from "../common/TermsPage";
import PrivacyPage from "../common/PrivacyPage";
import MapViewPage from "../common/MapViewPage";

function ServicePage() {
  const { page, currUserId } = useContext(Ctx);
  const [spData, setSpData] = useState(null);
  const [spLoading, setSpLoading] = useState(true);

  const loadSpData = async () => {
    try {
      const data = await api.serviceSync(currUserId);
      if (data) setSpData(data);
    } catch (e) {
      console.error("Service sync error:", e);
    } finally {
      setSpLoading(false);
    }
  };
  useEffect(() => { loadSpData(); }, [currUserId]);

  const sp = { data: spData, loading: spLoading, reload: loadSpData };
  switch (page) {
    case "dash": return <SpDash sp={sp} />;
    case "spJobs": return <SpJobsList sp={sp} />;
    case "spJobDetail": return <SpJobDetail sp={sp} />;
    case "spHistory": return <SpHistory sp={sp} />;
    case "spEarnings": return <SpEarnings sp={sp} />;
    case "mapView": return <MapViewPage sp={sp} />;
    case "settings": return <SettingsPage />;
    case "profile": return <ProfilePage />;
    case "faq": return <FaqPage />;
    case "terms": return <TermsPage />;
    case "privacy": return <PrivacyPage />;
    default: return <SpDash sp={sp} />;
  }
}

export default ServicePage;
